import {
  ConsolidationDocumentFormat,
  ConsolidationDocumentKind,
} from "@redotech/redo-fulfillment-operations-common/consolidation-document";
import { consolidationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const ConsolidationDocumentSchema = z.object({
  formats: z.array(z.enum(ConsolidationDocumentFormat)),
  kind: z.enum(ConsolidationDocumentKind),
  label: z.string(),
});
export type ConsolidationDocument = z.infer<typeof ConsolidationDocumentSchema>;

/** Returns only the documents that can be generated right now. */
export const listConsolidationDocuments = {
  name: "listConsolidationDocuments" as const,
  input: z.object({ consolidationId: consolidationIdFormat.schema }),
  output: z.object({ documents: z.array(ConsolidationDocumentSchema) }),
};
